import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 430.498 430.498' fill='none' className={className}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M215.249,0C96.653,0,0,96.653,0,215.249s96.653,215.249,215.249,215.249 s215.249-96.653,215.249-215.249S333.845,0,215.249,0z M31.347,215.249c0-101.355,82.547-183.902,183.902-183.902 c45.453,0,86.727,16.196,118.596,43.363L74.71,333.845C47.543,301.975,31.347,260.702,31.347,215.249z M215.249,399.151 c-44.931,0-86.204-16.196-118.073-42.841L356.31,97.176c26.645,31.869,42.841,73.143,42.841,118.073 C399.151,316.604,316.604,399.151,215.249,399.151z'
        fill={fillColor}
      />
    </svg>
  );
});

export default React.memo(Icon);
